import $ from 'jquery';
import Component from '../models/Component';

export default class boxcolor extends Component {
    constructor(element, context) {
        super(element, context);

        $(() => {
            let color = this.element.data('g-color');

            if (color) {
                this.element[0].style.backgroundColor = color;
                this.element[0].style.border = `3px solid ${color}`;
            }

        })
    }
}